<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box bg-maltia">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <!-- <img src="icon.png" alt="" height="22"> -->
          </span>
          <span class="logo-lg">
            <img src="assets/images/icon_white.png" alt="" height="17">
          </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <!-- <img src="icon.png" alt="" height="22"> -->
          </span>
          <span class="logo-lg">
            <img src="assets/images/icon_white.png" alt="" height="19">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>
    <div class="d-flex">

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" src="assets/images/noavatar.png" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{user.user}}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" href="javascript: void(0);" (click)="routingChangePassword()"><i
              class="bx bx-lock-open font-size-16 align-middle me-1 small"></i>
            Cambiar contraseña</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger small"></i>
            Salir</a>
        </div>
      </div>
    </div>
  </div>
</header>